<template>
  <v-container class="ma-0 pa-0" >
    <v-row class="ma-0 pa-0">
      <v-col  class="ma-0 pa-0" cols="12" xm="12">
        <v-text-field
          class= "ma-0 pa-0"
          outlined
          append-icon="mdi-microphone"
          @click:append="buscarAreas"
          v-on:keyup.enter="buscarAreas"
          @click:clear="limpiar"
          label="Buscar área"
          prepend-inner-icon="mdi-magnify"
          v-model="buscando"
          clearable
          :loading="loading"
          v-on:keyup.113 = "buscarAreas"
          hide-details
        ></v-text-field>

        <!-- <h3 class="mx-5 my-0">area: {{ nomarea }}   </h3> -->
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0" cols="12" xm="12">
        <p  class= "ma-1" v-if ="areas.length>0" >{{areas.length}} resultados</p>

        <v-data-table v-if ="areas.length>0"
          class="grey lighten-2"
          :headers="headers"
          :items="areas"
          ref="tabla"
          @click:row="seleccionar"
          item-key="idarea"
          hide-default-footer
          :items-per-page="longitud"
          fixed-header
          dense
          :loading="loading"
          hide-default-header
        >
            <template v-slot:item="{ item }" >
              <tr v-on:click.once="seleccionar(item)">
                <td>{{ item.idarea }}</td>
                <td>{{ item.nomarea }}</td>
              </tr>
           </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar" :timeout="3000" top
      :color="color"
      >
        {{text}}
        <v-btn
          color="white"
          text
          @click="snackbar = false"
        >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import { mapActions, mapGetters} from 'vuex'

export default {
  data: () => ({
    buscando:'',
    longitud:30,
    loading: false,
      
    areas:[],

    nomarea:'',
    idarea:'',
    //SNACKBAR
    text    : '',
    snackbar: false,
    color   : '',
      
    headers: [
      { text: 'Id',   align: 'start', value: 'idarea' },
      { text: 'area',  align: 'end', value: 'nomarea' },
         
    ],
  }),

  created(){
    this.getArea
      
    this.buscando = ''
    this.idarea   = ''

    if (this.getArea.idarea == undefined){
      this.buscando = ''
      this.idarea   = ''
  
    } else {
      this.buscando = this.getArea.nomarea
      this.idarea   = this.getArea.idarea
    }

  },

  watch:{
    getArea(){
      // this.limpiar()
      this.actualizarLeeareas()
    },

  },

  computed:{
    ...mapGetters('areas', ['getArea']),
  },

  methods:{
    ...mapActions('areas',['setArea']),

    actualizarLeeareas() {
      this.buscando = this.getArea.nomarea
      this.nomarea = this.getArea.nomarea
      this.idarea = this.getArea.idarea
    },

    buscarAreas() {

      console.log("a Buscar", this.buscando)
      var payload = {
        Buscar : this.buscando.trim()
      }

      this.loading = true
      //tienda3/api/v2/areas.find
        
      this.$http.post('v2/areas.find', payload).then(response=>{
        console.log(response.data)
        this.loading  = false
          
        if (response.data.Total > 0 ){
           
          this.areas = response.data.Data
          this.longitud = response.data.Total
          // console.log(" RESULTADOS",this.areas )
        } else {
          this.areas = []
          console.log("SIN RESULTADOS")
          this.areas = []
          this.snackbar = true
          this.text = "No se encontraron areas"
          this.color = "info"
        }
          
      }).catch(()=>{
        this.areas= []
        this.loading  = false
        console.log()})
    },
      
    limpiar(){

      this.areas=[]
      this.idarea =''
      this.nomarea = ''
      this.buscando= ''
      var item= {}
      this.setArea(item)
    },

    seleccionar(item){
      //console.log("row",row) // row.select(true);
      console.log("item", item)
      this.nomarea = item.nomarea
      this.idarea = item.idarea
        
      this.buscando = item.nomarea
      this.areas = []
      this.setArea(item)
    },
      
  }
}
</script>